<template>
    <div>
        
        <b-row v-show="show_step == false">
            <b-col class="mt-2" cols="2">
                <b-button class="me-2" variant="light" @click="$eventHub.$emit('navigateBack')">
                    <i class="fas fa-arrow-left"></i> Back
                </b-button>
            </b-col>

            <b-col cols="4" style="text-align: center; padding-left: 5%; padding-right: 5%;">
                <div class="height: 2rem;">
                    <i style="font-size: 2rem; color: dodgerblue;" class="far fa-bell "></i>
                </div>
                <h4><strong>{{status.responses_recieved}}</strong> Applicant Responses Recieved</h4>
            </b-col>

            <b-col cols="4" style="text-align: center; padding-left: 5%; padding-right: 5%;">
                <div class="height: 2rem;">
                    <i style="font-size: 2rem; color: red;" class="far fa-question-circle"></i>
                </div>
                <h4><strong>{{status.awaiting_response}}</strong> Queries Awaiting Response</h4>
            </b-col>

            <b-col cols="2"></b-col>
        </b-row>


        <!-- Steps table for selected client -->
        <div v-show="show_step == false">
            <webix-ui :config="config" v-model="step_data"></webix-ui>
        </div>


        <!-- show progress position of selected step -->
        <ProgressBar @back="backEvent" v-if="show_step == true" />

        <!-- show selected step -->
        <div v-if="show_step == true">
            <b-row>
                <b-col cols="12">
                    <ViewContainer @backEvent="backEvent" />
                </b-col>
            </b-row>
        </div>
    </div>
</template>

<script>
import ViewContainer from './view-container.vue'
import ProgressBar from '@/components/admin/applicants/progress.vue'
import _ from 'lodash'
import { ccbAdminState, ccbAdminMethods } from '@/state/helpers'
export default {
    components:{
        ViewContainer,
        ProgressBar
    },
    data:() => ({
        status:{
            responses_recieved: 0,
            awaiting_response: 0,
        },

        show_step: false,

        clickedAction: false,

        config:{
            id: 'stepsTable',
            view: 'datatable',
            css: "datatableUsers webix_header_border webix_data_border",
            select: 'row',
            hover: 'webix-row-hover',
            autoheight: true,
            fillspace: true,
            data:[],
            columns:[
                { id: 'id', header:'', hidden: true},
                { id: 'index', header:'', fillspace: 0.1},
                { id: 'status', header:'', fillspace: 0.1, template: function(object){
                    if(object.status == 'complete'){
                        return '<span title="Complete" class="webix_icon_hover webix_icon complete_icon fas fa-check"/>';
                    }
                    else if(object.status == 'in_progress'){
                        return '<span title="In Progress" class="webix_icon_hover webix_icon busy_icon fas fa-question"/>'
                    }
                    else if(object.status == 'pending_validation'){
                        return '<span title="Waiting For Validation" class="webix_icon_hover webix_icon pending_icon fas fa-user-clock"/>'
                    }
                    else if(object.status == 'pending_revalidation'){
                        return '<span title="Waiting For Re-Validation" class="webix_icon_hover webix_icon revalidation_icon fas fa-exclamation-triangle"/>'
                    }
                    else if(object.status == 'pending_client_review'){
                        return '<span title="Waiting For Client Review" class="webix_icon_hover webix_icon pending_icon fas fa-redo    "/>'
                    }
                    else{
                        return ``;
                    }
                }},
                { id: 'name', header:'Activity', fillspace: true},
                { id: 'due_date', header:'Date', fillspace: 0.4},
                { id: 'liason_contact', header:'Liason Contact', fillspace: 0.5},
                { id: 'ccb_contact', header:'CCB Contact', fillspace: 0.5},
                { id: 'actions', header:'', fillspace: 0.2,  template: function(object){
                    let comment = '';
                    if(object.comments){
                        comment = '<i title="View comment" class="webix_icon_hover webix_icon timeline_comment comment_true fas fa-comment"></i>'
                    }
                    else{
                        comment = '<i title="No Comment" class="webix_icon_hover webix_icon timeline_comment comment_false far fa-comment"></i>'
                    }

                    let action = '';
                    if(object.action_required){
                        action = '<i title="Go to action" class="webix_icon_hover webix_icon timeline_action action_true far fa-question-circle"></i>'
                    }
                    else{
                        action = '<i title="No action" class="webix_icon_hover webix_icon timeline_action action_false far fa-question-circle"></i>'
                    }

                    return `<div style="text-align: center;">${comment} &nbsp; ${action}</div>`
                }}
            ],
            on:{
                //eslint-disable-next-line
                onItemClick(id, e, node){
                    var el = this.$scope.$parent;
                    setTimeout(()=>{
                        if(el.clickedAction == false){
                            el.selectRow(id.row);
                        }
                    }, 55)
                    
                }
                
            },
        },
    }),
    computed:{
        ...ccbAdminState,
        step_data(){
            //return this.client_data.client;
            if(this.client_data.appllication == undefined){
                return [];
            }
            else{
                //return this.client_data.appllication.steps;
                let steps = _.cloneDeep(this.client_data.appllication.steps);
                steps.forEach(((step, index) => {
                    step['index'] = index + 1;
                }))
                return steps;
            }
        }
    },
    methods:{
        ...ccbAdminMethods,
        selectRow(step_id){
            let params = {
                client_id: this.client_data.client.id,
                step_id: step_id,
            }
            this.loadClientStepData(params)
            .then(()=>{
                this.show_step = true;
                //this.$emit('selectedRow', id);
            })
            .catch(()=>{
                console.log('err')
            })
        },
        backEvent(){
            this.show_step = false;
            this.$nextTick(()=>{
                this.refreshTable();
            })
        },
        refreshTable(){
            //eslint-disable-next-line
            let table = $$('stepsTable');
            if(table != undefined){
                table.refresh();
            }
        }
    },
    mounted(){
        this.$nextTick(()=>{
            this.refreshTable();
        })
    },
}
</script>

<style>
.complete_icon{
    color: rgb(21, 192, 21);
}
.busy_icon{
    color: dodgerblue;
}
.pending_icon{
    color: #f1734f;
}
.revalidation_icon{
    color: #ff3737;
}
</style>